import * as React from 'react';
import clsx from 'clsx';
import { withStyles, WithStyles, generateStaticClassName, createStyles } from '@domonda/ui/styles';
import { menuItemClassName } from './MenuItem';

const styles = createStyles(({ spacing }) => ({
  root: {},
  list: {
    display: 'flex',
    flexDirection: 'column',
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  horizontal: {
    flexDirection: 'row',
    [`& .${menuItemClassName}`]: {
      margin: spacing(0, 1),
      '&:first-child': {
        marginLeft: 0,
      },
    },
  },
}));

interface Props {
  children: React.ReactNode;
  className?: string;
  horizontal?: boolean;
}

const menuClassName = generateStaticClassName('Menu');

const Menu: React.FC<Props & WithStyles<typeof styles>> = (props) => {
  const { children, classes, horizontal } = props;

  const className = clsx(classes.list, {
    [classes.horizontal]: horizontal,
  });

  return (
    <nav className={clsx(menuClassName, classes.root)}>
      <ul className={className}>{children}</ul>
    </nav>
  );
};

const StyledMenu = withStyles(styles)(Menu);
export { StyledMenu as Menu, menuClassName };
